/** A cycle's prices at the precision its exchange quotes them. */
import type { SlotResponse } from "@/shared/api";
import { quote, quoteDecimals } from "@/shared/money/money";

export function slotDecimals(slot: SlotResponse): number | null {
  const levels = slot.evidence?.placement?.levels ?? [];
  return quoteDecimals([slot.current_price, ...levels.map((level) => level.planned_order_price)]);
}

/** Formats any price of this cycle the way the exchange prints it. */
export function slotQuote(slot: SlotResponse): (value: string) => string {
  const decimals = slotDecimals(slot);
  return (value) => quote(value, decimals);
}
